<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">Doctors List</h1>
	    </div> 
	    <div class="col-sm-6 float-left add_user_btn" *ngIf="myrole=='1' || myrole=='4' || myrole=='6'">
            <a *ngIf="myrole=='1' && userId=='89'" class="btn btn-success mr-3" (click)="showModal()"><i class="fa fa-file-excel"></i> Update Doctor Csv</a>
	        <a routerLink="/create-doctor" class="btn btn-success">
		        <i class="fa fa-plus" aria-hidden="true"></i> Add New Doctor
		    </a>
	    </div>

    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-4 mt-4">
                        <!-- <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadDoctorsList(0,perpage)" placeholder="Search" /></div> -->
                        <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-3">
                            <!-- <mat-select  placeholder="Circle" (selectionChange)="loadDoctorsList(0,perpage)" [(ngModel)]="circle"  (click)="setSearchValue()"> -->
                                <mat-select  placeholder="Circle" [(ngModel)]="circle"  (click)="setSearchValue()">
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3">
                            <!-- <mat-select  placeholder="Status" (selectionChange)="loadDoctorsList(0,perpage)" [(ngModel)]="status"> -->
                                <mat-select  placeholder="Status" [(ngModel)]="status">
                                <mat-option >All</mat-option>
                                <mat-option value="1">Active</mat-option>
                                <mat-option value="0">In-Active</mat-option>
                                <mat-option value="2" *ngIf="myrole=='1' || myrole=='4'">Deleted</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3">
                            <!-- <mat-select  placeholder="Treatment Catergory"  [(ngModel)]="treatment_category_filter" multiple (selectionChange)="loadDoctorsList(0,perpage)"> -->
                                <mat-select  placeholder="Treatment Catergory"  [(ngModel)]="treatment_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-4">
                            <!-- <mat-select  placeholder="Zone" (selectionChange)="loadDoctorsList(0,perpage)" [(ngModel)]="zone"> -->
                                <mat-select  placeholder="Zone" [(ngModel)]="zone">
                                <mat-option >All</mat-option>
                                <mat-option value="1">East</mat-option>
                                <mat-option value="2">West</mat-option>
                                <mat-option value="3">North</mat-option>
                                <mat-option value="4">South</mat-option>
                                <mat-option value="5">Central</mat-option>
                                
                            </mat-select>
                        </div>

                        <div class="col-sm-3 mt-4">
                            <button type="button" class="btn btn-primary mb-4" (click)="loadDoctorsList(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-3 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadDoctorsList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button *ngIf="myrole=='1' || myrole=='4' || myrole=='6' || myrole=='9'" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportDoctorList()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>

                 <!-- Update Doctor Rating -->
                 <div class="col-sm-3 p-3" *ngIf="myrole=='1'">
                    <a class="btn btn-success text-white" (click)="showRankingStatusUpdateModal()"><i class="fa fa-file-excel"></i> Update Doctor Ranking</a><br>
                    <a href="{{sc3Url}}crm/doctors/doctor-rating-update-sample-import.csv" target="_blank">Sample CSV</a>
                </div>

                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped doctorTable">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Profile Pic</th>
                        <th class="tablefixcoloumn">Name</th>
                        <th>Gender</th>
                        <th>Contact Number</th>
                        <th>Circle</th>
                        <th>City</th>
                        <th>Zone</th>
                        <th>Address</th>
                        <th>Qualification</th>
                        <th>Year of Experience</th>
                        <th>Treatment Catergory</th>
                        <th>Medical Speciality</th>
                        <th *ngIf="myrole=='1' || myrole=='4'">Qualification degree</th>
                        <th *ngIf="myrole=='1' || myrole=='4'">Address proof</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">Indemnity Bond</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">CV</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">PAN card</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">Medical Registration Certificate</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">Cancelled cheque copy</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">Glamyo Agreement</th>
                        <th>Status</th>
                        <th>Created at</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='6'">Display On Landing Page</th>
                        <th *ngIf="myrole=='1' || myrole=='3' || myrole=='4'">Active/In-Active</th>
                        <th *ngIf="myrole=='1' || myrole=='4' || myrole=='6'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of doctorsList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>
                            <img class="profile_pic" *ngIf="user.image; else noImage" alt="profile" src="{{sc3Url}}{{user.image}}">
                            <ng-template #noImage>
                                <img class="profile_pic"  alt="profile" src="assets/images/defalutpic.png">
                            </ng-template>
                        </td>
                        <td class="tablefixcoloumn"><a href="{{user.dLink}}" target="_blank">{{user.name}}</a></td>
                        <td>
                            <div *ngIf="user.gender == '1'">
                                <span>Male</span>
                            </div>
                            <div *ngIf="user.gender == '2'">
                                <span>Female</span>
                            </div>
                            <div *ngIf="(user.gender == '' || user.gender == 0 || !user.gender)">
                                <span>NA</span>
                            </div>
                        </td>
                        <td>{{user.mobile}}</td>
                       	<td>{{user.circle_name}}</td>
                        <td>{{user.cityName}}</td>
                        <td>
                            <div *ngIf="user.zone == '1'">
                                <span>East</span>
                            </div>
                            <div *ngIf="user.zone == '2'">
                                <span>West</span>
                            </div>
                            <div *ngIf="user.zone == '3'">
                                <span>North</span>
                            </div>
                            <div *ngIf="user.zone == '4'">
                                <span>South</span>
                            </div>
                            <div *ngIf="user.zone == '5'">
                                <span>Central</span>
                            </div>
                        </td>
                        <td>{{user.address}}</td>
                        <td>{{user.qualification}}</td>
                        <td>{{user.work_exp}}</td>
                        <td [innerHTML]="getCatergoryName(user.treatment_categories_name) | safe:'html'"></td>
                        <td>{{user.specialist}}</td>
                        <td *ngIf="myrole=='1' || myrole=='4'">
                            <div *ngIf="user.uploadedfiles[1].length > 0; else nodegree">
                                <span *ngFor="let degree of user.uploadedfiles[1]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #nodegree>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4'">
                            <div *ngIf="user.uploadedfiles[2].length > 0; else noAadress">
                                <span *ngFor="let degree of user.uploadedfiles[2]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noAadress>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[3].length > 0; else noBond">
                                <span *ngFor="let degree of user.uploadedfiles[3]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noBond>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[4].length > 0; else noCV">
                                <span *ngFor="let degree of user.uploadedfiles[4]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noCV>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[5].length > 0; else noPanCard">
                                <span *ngFor="let degree of user.uploadedfiles[5]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noPanCard>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[6].length > 0; else noCertificate">
                                <span *ngFor="let degree of user.uploadedfiles[6]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noCertificate>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[7].length > 0; else noCancelcheque">
                                <span *ngFor="let degree of user.uploadedfiles[7]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noCancelcheque>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='9'">
                            <div *ngIf="user.uploadedfiles[9].length > 0; else noAgreement">
                                <span *ngFor="let degree of user.uploadedfiles[9]"><a href="{{sc3Url+degree.filepath}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noAgreement>
                                Not uploaded
                            </ng-template>
                        </td>

                        <td>
                        	<span class="badge bg-green-light" *ngIf="user.status=='1'">Active</span>
                        	<span class="badge bg-azure-light" *ngIf="user.status=='0'">In-Active</span>
                            <span class="badge bg-red" *ngIf="user.status=='2'">Deleted</span>
                        </td>
                        <td>{{user.created_at*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <!-- <td><input style="width: 80px;" type="number" value="{{user.order_id}}" (keyup)="updateDoctorOrder($event.target.value,user.id);"></td> -->
                        <td *ngIf="myrole=='1' || myrole=='4' || myrole=='6'">
                            <mat-slide-toggle [checked]="user.display_on_LP=='1'" (change)="showOnLP($event,user.id,index)"></mat-slide-toggle>
                        </td>

                        <td *ngIf="myrole=='1' || myrole=='3' || myrole=='4'">
                            <mat-slide-toggle [checked]="user.status=='1'" (change)="onStatusChange($event,user.id,index)"></mat-slide-toggle>
                        </td>
                        <td *ngIf="myrole=='1' || myrole=='3' || myrole=='4' || myrole=='6'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{user.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{user.id}}">
                                    <a class="dropdown-item" routerLink="/update-doctor/{{user.id}}"><i class="fa fa-pen"></i> Update</a>
                                    <a *ngIf="myrole=='1' || myrole=='3' || myrole=='4' " class="dropdown-item" routerLink="/doctor-opd/{{user.id}}"><i class="fa fa-eye"></i> View OPD</a>
                                    <a *ngIf="myrole=='1' || myrole=='3' || myrole=='4' " class="dropdown-item" routerLink="/doctor-ipd/{{user.id}}"><i class="fa fa-eye"></i> View IPD</a>

                                </div>
                             </div>
                        </td>

                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !doctorsList.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Doctors not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>

</div>


<!--  Modal For Update Doctor Ranking Field -->
<div class="modal fade" id="myModalLeadStatusUpdate">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideRankingStatusUpdateModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvDoctorRankingFieldUpdate (change)="rankingUpdate($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideRankingStatusUpdateModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!--  Modal For Update Doctor Data -->
<div class="modal fade" id="updateDataModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Import Doctor Data </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <label class="col-sm-12">Upload CSV</label>
                        <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)"
                            class="form-control" />
                    </div>
                    <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                </div>
                <div class="form-group" [innerHTML]="uploaded_msg | safe:'html'">

                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn" (click)="hideModal()">Close</button>
            </div>
        </div>
    </div>
</div>
